import _extends from "@babel/runtime/helpers/extends";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import { cloneEnumerableProperty } from '@alilc/lowcode-utils';
import adapter from '../adapter';
export function compWrapper(Comp) {
  var _adapter$getRuntime = adapter.getRuntime(),
      createElement = _adapter$getRuntime.createElement,
      Component = _adapter$getRuntime.Component,
      forwardRef = _adapter$getRuntime.forwardRef;

  var Wrapper = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Wrapper, _Component);

    function Wrapper() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = Wrapper.prototype;

    // constructor(props: any, context: any) {
    //   super(props, context);
    // }
    _proto.render = function render() {
      return createElement(Comp, this.props);
    };

    return Wrapper;
  }(Component);

  return cloneEnumerableProperty(forwardRef(function (props, ref) {
    return createElement(Wrapper, _extends({}, props, {
      forwardRef: ref
    }));
  }), Comp);
}